module.exports = __webpack_public_path__ + "static/img/4.1a941ef.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/winter/dice/4.png
// module id = kYLo
// module chunks = 2